<template>
    <div>
        <div class="hotBox" v-if="onShow">
            <p class="newHot">最新热款</p>
            <div class="backgroundHot">
                <Carousel autoplay loop dots="none" :autoplay-speed="3000" arrow="never" easing="linear" @on-click="productDetail">
                    <CarouselItem v-for="(item,index) in productList" :key="index">
                        <div class="product">
                            <div class="imgs">
                                <img :src="item.faceImagePath" :alt="item.productName">
                            </div>
                            <b style="margin-top:-8px">{{item.productName}}</b>
                            <p style="color:#FF9000">{{item.length}}mm*{{item.width}}mm*{{item.height}}mm</p>
                            <p v-if="item.productType == 'sale'" style="color:#FF9000;margin-top:-5px">￥<span style="font-size:20px">{{item.benchmarkPrice}}/</span>个</p>
                        </div>
                    </CarouselItem>
                </Carousel>

            </div>
            <p class="cancel" @click="onMotion">X</p>
        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            onShow: "",
            productList: []
        }
    },
    created() {
        this.getHotProuct()
    },
    mounted() {
        this.onShow = window.sessionStorage.getItem('montionShow') ? false : true;
    },
    methods: {
        onMotion() {
            this.onShow = false;
            window.sessionStorage.setItem('montionShow', this.onShow);
        },
        getHotProuct() {
            let data = {
                url: "http://MID-CLIENT-MALL/messageService/shelfService/queryProductList",
                body: {
                    queryParams: { shelfIdList: "'shelf_hot'" }
                }
            }

            let param2 = {
                url: 'http://CORE-TARGET/messageService/targetModelService/queryAllTargetModel',
                body: {}
            }
            let p1 = this.invoke(data)
            let p2 = this.invoke(param2);

            Promise.all([p1, p2]).then(([productList, modelList]) => {
                this.productList = productList.map(p => {
                    let m = modelList.find(({ modelId }) => modelId == p.targetModelCode);
                    return { ...p, ...m };
                });
            })
        },
        productDetail(index) {
            let { productId } = this.productList.filter((item, val) => index == val)[0];
            this.$router.push({
                path: '/product-details',
                query: { productId }
            });
        },
    }

}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1100px) {
    .hotBox {
        display: none;
    }
}
@keyframes delay {
    0% {
        bottom: -500%;
    }
    20% {
        bottom: -400%;
    }
    40% {
        bottom: -300px;
    }
    60% {
        bottom: -200px;
    }
    80% {
        bottom: -100px;
    }
    90% {
        bottom: -50px;
    }
    100% {
        bottom: 20px;
    }
}
.hotBox {
    width: 230px;
    height: 399px;
    position: relative;
    z-index: 199;
    border-radius: 15px;
    position: fixed;
    left: 2px;
    bottom: 20px;
    animation: delay 2s linear 1;
    .newHot {
        font-size: 13px;
        font-weight: bold;
        position: absolute;
        top: 122px;
        left: 85px;
    }
    .backgroundHot {
        width: 230px;
        height: 399px;
        background: url("~assets/image/backgroudHot.png") no-repeat;
        overflow: hidden;
        .product {
            width: 202px;
            margin: 145px 0px 0 12px;
            display: flex;
            flex-direction: column;
            align-items: center;
            border-radius: 60px;
            cursor: pointer;
            b {
                font-size: 16px;
            }

            .imgs {
                width: 150px;
                img {
                    width: 100%;
                }
            }
        }
    }
    .cancel {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid #ddd;
        position: absolute;
        left: 5px;
        top: 10px;
        text-align: center;
        line-height: 20px;
        color: #ddd;
        cursor: pointer;
        display: none;
        transition: all 5s;
    }
    &:hover .cancel {
        display: block;
    }
}
</style>